import { faBars, Icon, Sidebar } from '@oppy/omniv2-ui';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Header, MainNav } from '@/components';

export default function MainLayout() {
  const [desktopMenuIsVisible, setDesktopMenuIsVisible] = useState(false);

  return (
    <main
      data-testid="main-layout"
      className="flex h-screen items-start bg-body-background"
    >
      {/* Desktop menu. */}
      <section className={'hidden w-0 sm:w-[260px] md:block'}>
        <MainNav />
      </section>

      {/* Mobile menu. */}
      <Sidebar
        visible={desktopMenuIsVisible}
        onHide={() => setDesktopMenuIsVisible(old => !old)}
        className="bg-white shadow md:hidden"
        pt={{
          closeButton: { className: 'mt-4 mr-4' },
        }}
      >
        <MainNav />
      </Sidebar>

      {/* Toggle menu button. */}
      {!desktopMenuIsVisible && (
        <div className="fixed left-0 top-2 z-20 flex size-10 items-center justify-center rounded-r-full bg-primary text-white shadow md:hidden">
          <Icon
            icon={faBars}
            className="size-4"
            role="button"
            onClick={() => setDesktopMenuIsVisible(old => !old)}
          />
        </div>
      )}

      <section className="flex h-screen flex-1 flex-col overflow-auto px-6 pb-6">
        <Header />
        <Outlet />
      </section>
    </main>
  );
}
